// extracted by mini-css-extract-plugin
export default {"modalContentClassName":"ShowCertificateModal_modalContentClassName__w8iPm","modalCertificateContainer":"ShowCertificateModal_modalCertificateContainer__j1U9v"};